import { BillingEmptyState } from '@/features/billing/components/BillingEmptyState'
import { Button } from '@/components/Button'

export interface PaymentMethodsEmptyStateProps {
  canAddPaymentMethod: boolean
  isAddPending: boolean
  onNewPaymentMethod: () => unknown
  corporateMode: boolean
}

export function PaymentMethodsEmptyState({
  canAddPaymentMethod,
  isAddPending,
  onNewPaymentMethod,
  corporateMode,
}: PaymentMethodsEmptyStateProps) {
  return (
    <BillingEmptyState
      corporateMode={corporateMode}
      title="There are no Payment Methods"
      subtitle="No payment methods have been set up."
    >
      {canAddPaymentMethod && (
        <Button
          label="Add New Payment Method"
          isDisabled={isAddPending}
          isPending={isAddPending}
          variant="primary"
          onPress={onNewPaymentMethod}
          testId="add-new-payment-method-button"
        />
      )}
    </BillingEmptyState>
  )
}
